// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__n_9h3","title":"ClientInsurance_title__x9_8z","itemText":"ClientInsurance_itemText__3zuxE"};